import {browserTracingIntegration} from '@sentry/browser';
import {init, User} from '@sentry/react';

import {GetCurrentUserInfoApiResponse} from '@dms/api/shared';
import {getWorkspaceFromUri} from '@dms/routes';

export function sentryInit(user: GetCurrentUserInfoApiResponse) {
  const {workspace} = getWorkspaceFromUri();

  const roles = user.roles?.map((r) => r.title).toString();

  const branch = user.defaultBranch?.name;

  const userTag: User = {
    id: user.id,
    email: user.email,
    username: user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : user.email,
  };

  init({
    dsn: process.env.SENTRY_DSN,
    tracesSampleRate: 1.0,
    debug: false,
    enabled: process.env.ENV_TYPE === 'prod',
    environment: process.env.ENV_TYPE,
    initialScope: {
      tags: {workspace, roles, branch},
      user: userTag,
    },
    integrations: [browserTracingIntegration()],
    release: process.env.COMMIT_HASH,
    normalizeDepth: 10,
    normalizeMaxBreadth: 10,
    // We do not care about these errors, so we don't want to report them to Sentry
    ignoreErrors: [/network error/i],
  });
}
